import Model from './Model';

class AdminSettings extends Model {
  getId() {
    return this.attrs.id;
  }

  setId(value) {
    this.attrs.id = value;
    return this;
  }

  getGraceNewStore() {
    return this.attrs.graceNewStore;
  }

  setGraceNewStore(value) {
    this.attrs.graceNewStore = value;
    return this;
  }

  getExpiryGrace() {
    return this.attrs.expiryGrace;
  }

  setExpiryGrace(value) {
    this.attrs.expiryGrace = value;
    return this;
  }

  getTrialPeriod() {
    return this.attrs.trialPeriod;
  }

  setTrialPeriod(value) {
    this.attrs.trialPeriod = value;
    return this;
  }
}
export default AdminSettings;
